// Entry point for the build script in your package.json

// Rails
import Rails from "@rails/ujs";
Rails.start();

// Ready handler
import readyHandler from "./lib/readyHandler";
readyHandler.start();

// Responsive embeds
import responsiveEmbeds from "./lib/responsiveEmbeds";
responsiveEmbeds();

// React
import * as Tombolo from "tombolo";
import * as components from "./components";
Tombolo.start(components);

import "./features/expandableBlocks";
import "./features/nav";
import "./features/popup";
import "./features/stipendTabs";
